import { Link, useLocation } from 'react-router-dom';
import { useLocale } from '../../app/locale/LocaleProvider';
import { parseChallengePayload } from '../../engine/sharePayload';
import { findPersonalityType } from '../../data/taxonomy';

export function ChallengePage() {
  const location = useLocation();
  const { locale } = useLocale();
  const payload = parseChallengePayload(location.search);
  const friendType = findPersonalityType(payload.typeId);
  const friendName = friendType ? (locale === 'zh-CN' ? friendType.zhShare : friendType.enShare) : payload.typeId;

  return (
    <main className="challenge-entry">
      <p>{locale === 'zh-CN' ? '你的朋友测出了' : 'Your friend got'}</p>
      <h1>{friendName}</h1>
      <p>
        {locale === 'zh-CN'
          ? '玩同款 3 题，看看你们是不是同一种社交事故人格。'
          : 'Take the same 3-scene challenge and compare your Social Mishap type.'}
      </p>
      <Link to={`/challenge/play${location.search}`}>
        {locale === 'zh-CN' ? '玩同款挑战' : 'Take the same 3-scene challenge'}
      </Link>
      <Link to="/play">
        {locale === 'zh-CN' ? '直接完整测试' : 'Take the full test'}
      </Link>
    </main>
  );
}
